var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-setting"},[_c('vh-radio-group',{model:{value:(_vm.currentLang),callback:function ($$v) {_vm.currentLang=$$v},expression:"currentLang"}},[_c('vh-radio-card',{attrs:{"label":"zh"}},[_vm._v("简体中文")]),_c('vh-radio-card',{attrs:{"label":"en"}},[_vm._v("English")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }